import { withTranslation } from 'react-i18next'

import NotificationsListItem from './NotificationsListItem'

export default withTranslation('user')(NotificationsListItem)
